import object from '@mailobj-browser/front/js/utils/object.js'
import change from '@mailobj-browser/front/js/events/types/change.js'
import { onMailModified } from './mailModified.js'

const onChange = object(onMailModified, {
  type: change
})

export default button => {
  onChange.listen(button)
}
